<button
  mat-icon-button
  [disabled]='!offerPropositionId'
  (click)='openCandidateEvaluation()'
  [matTooltip]="'CANDIDATE_EVALUATIONS' | translate"
  color='primary'
>
  <mat-icon inline>reviews</mat-icon>
</button>
